import React, { useState } from 'react';

import { LinearProgress } from '@material-ui/core';

import { INTERFACE_PERMISSIONS } from '@vyce/core/src/types';
import { usePermissions } from '@vyce/core/src/hooks/usePermissions';
import { Messages } from '@vyce/core/src/modules/messagesModule/Messages';
import { userToChatUser } from '@vyce/core/src/utils/chat';

import { GetStarted } from './components/GetStarted';
import { RestrictedMessages } from './components/RestrictedMessages';
import { MessagingActivatedDialog } from './components/MessagingActivatedDialog';
import { useTypedSelector } from '../../hooks';

export const EmployerMessages: React.FC = () => {
  const { user } = useTypedSelector(state => state);
  const { can } = usePermissions();
  const { selectedCompanyAppData, selectedCompany } = useTypedSelector(state => state.helper);
  const [justActivated, setJustActivated] = useState<boolean>(false);
  const chatUser = userToChatUser(user);

  const hadSubscription =
    (!!selectedCompanyAppData?.subscription?.uuid && !selectedCompanyAppData.subscription.active) || false;
  const hasBillingPermissions = can(INTERFACE_PERMISSIONS.BILLING);
  const selectedCompanyIsSubscribed = selectedCompanyAppData?.subscription?.active ?? false;

  if (selectedCompanyAppData?.companyDataLoading) {
    return <LinearProgress />;
  }

  if (!selectedCompany?.uuid) {
    return (
      <GetStarted
        hadSubscription={hadSubscription}
        hasPermissions={hasBillingPermissions}
        hasSubscription={selectedCompanyIsSubscribed}
      />
    );
  }

  if (!selectedCompanyAppData?.messagingSubscription) {
    return (
      <RestrictedMessages
        chatUser={chatUser}
        companyId={selectedCompany.uuid}
        hadSubscription={hadSubscription}
        hasSubscription={selectedCompanyIsSubscribed}
        hasPermissions={hasBillingPermissions}
        onActivated={() => setJustActivated(true)}
      />
    );
  }

  return (
    <>
      <Messages user={chatUser} companyId={selectedCompany.uuid} route="/messages" launcherClearance />

      <MessagingActivatedDialog open={justActivated} onClose={() => setJustActivated(false)} />
    </>
  );
};
